var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBlueLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "placeholder",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.733,
    height: 28.064,
    viewBox: "0 0 19.733 28.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M85.866,0a9.868,9.868,0,0,0-8.394,15.055L85.3,27.676a.822.822,0,0,0,.7.389h.007a.822.822,0,0,0,.7-.4l7.632-12.743A9.868,9.868,0,0,0,85.866,0ZM92.93,14.077,85.991,25.663,78.87,14.188a8.227,8.227,0,1,1,14.06-.111Z",
    transform: "translate(-76)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(5.262 5.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M170.6,90a4.6,4.6,0,1,0,4.6,4.6A4.61,4.61,0,0,0,170.6,90Zm0,7.684a3.08,3.08,0,1,1,3.075-3.08A3.082,3.082,0,0,1,170.6,97.684Z",
    transform: "translate(-166 -90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlueLocation);
export default __webpack_public_path__ + "static/media/icon_blue_location.697a7a4a770683e1ebea4772bc488cff.svg";
export { ForwardRef as ReactComponent };